module.exports = __webpack_public_path__ + "static/parag-a8ced7ac88cfcd7a0445498eb196ab56.png";